export default "__VITE_ASSET__njISVESS__"